import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const BroadbandComparisonIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g transform="translate(3 32)">
        <path
          d="M1 16.6h41.4v-3.1c0-3.4-2.7-6.1-6.1-6.1H7.1C3.7 7.4 1 10.1 1 13.5v3.1z"
          fill="#ffffff"
          className={classnames(styles.white, styles.defaultStrokeColor)}
          stroke="#000000"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M15.6 11.1c.5 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .5-1 1-1z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M18.6 11.1c.5 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .5-1 1-1z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M21.7 11.1c.5 0 1 .4 1 1s-.4 1-1 1c-.5 0-1-.4-1-1s.5-1 1-1z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M24.7 11.1c.5 0 1 .4 1 1s-.4 1-1 1c-.5 0-1-.4-1-1s.5-1 1-1z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M27.8 11.1c.5 0 1 .4 1 1s-.4 1-1 1c-.5 0-1-.4-1-1s.5-1 1-1z"
          fill="#000000"
          className={styles.defaultStrokeColor}
          fillOpacity=".6014"
          fillRule="evenodd"
        />
      </g>
      <g transform="translate(.75 1)">
        <path
          d="M24 13.5c1.8 0 3.3 1.5 3.3 3.3s-1.5 3.3-3.3 3.3-3.3-1.5-3.3-3.3 1.5-3.3 3.3-3.3z"
          fill="#ffffff"
          className={classnames(styles.white, styles.defaultStrokeColor)}
          stroke="#000000"
          strokeWidth="1.5"
        />
        <path
          d="M16.9 10.1c-2 2-2.9 4.4-2.9 7.2s1 5.1 2.9 7.2M12 5.3c-3.3 3.5-4.9 7.6-4.9 12s1.6 8.4 4.9 12M7.2.5C2.7 5.5.5 11.1.5 17.2S2.7 29.1 7.2 34"
          fill="none"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M35.6 5.3c3.3 3.5 5 7.6 5 12s-1.7 8.4-5 12"
          fill="none"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M31.1 10.1c2 2.2 2.9 4.6 2.9 7.2s-1 4.9-2.9 7.2m9.5-24c4.6 5 7 10.5 7 16.7s-2.3 11.9-7 16.7"
          fill="none"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M24 20.1v18.3"
          fill="none"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <g transform="translate(22.25 22.25)">
        <path
          clipRule="evenodd"
          d="M15.7 5.2c5.7 0 10.4 4.6 10.4 10.4S21.4 26 15.7 26 5.3 21.4 5.3 15.6 9.9 5.2 15.7 5.2z"
          fill="#ffffff"
          className={classnames(styles.white, styles.defaultStrokeColor)}
          fillRule="evenodd"
          stroke="#000000"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M20 21.5v-2.2h-5.3c.4-.4.5-.9.6-1.3s.1-1.1-.1-1.7h2.7v-2H15c-.4-1.6-.2-2.6.5-3.1 1-.6 2.4-.4 3.4.5h.9v-2c-.6-.6-3.3-1.5-5.7-.2-1.6.9-2.2 2.4-1.7 4.9h-.7v1.8h1.2c.2.9.2 1.7 0 2.2-.2.6-.6 1-1.2 1.2v1.8H20z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
}
